import React from 'react'
import { ShieldCheck, Cog, FileClock, Lock, Layers, Gauge, Network, Building2 } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { ENTERPRISE } from '../data'
const ICONS = { ShieldCheck, Cog, FileClock, Lock, Layers, Gauge, Network, Building2 }
export default function Enterprise() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Enterprise Trading Infrastructure</Eyebrow>
          <SectionHeading align="center"
            title={<>Trading that <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">passes procurement.</span></>}
            subtitle="Eight non-negotiables every Kalki Ai Cloud tenant inherits — with white-label deployment as first-class citizenship."
          />
        </div>
        <FeatureGrid items={ENTERPRISE} icons={ICONS} cols={4} />
      </Container>
    </section>
  )
}
